export const INVOICE_PAYMENT_STATUS_UNPAID  =  '0';
export const INVOICE_PAYMENT_STATUS_PAID  =  '1';
export const INVOICE_PAYMENT_STATUS_PAYMENT_PROCESSING  =  '2';
export const INVOICE_PAYMENT_STATUS_PAYMENT_ACTION  =  '3';
export const INVOICE_PAYMENT_STATUS_PAYMENT_PENDING_CAPTURE  =  '4';
export const INVOICE_PAYMENT_STATUS_PAYMENT_PENDING_CONFIRM  =  '5';
export const INVOICE_PAYMENT_STATUS_PAYMENT_ERROR  =  '-1';
